import React, { Component } from 'react';
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
    Tabs,
    Tab,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControlLabel,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Avatar,
    IconButton,
    DialogContentText
} from '@mui/material';
import {
    People as PeopleIcon,
    ShoppingBag as ShoppingBagIcon,
    AttachMoney as AttachMoneyIcon,
    Visibility as VisibilityIcon,
    Add as AddIcon,
    Search as SearchIcon,
    FileDownload as FileDownloadIcon,
    BarChart as BarChartIcon,
    MoreVert as MoreVertIcon,
} from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';

class Clients extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0,
            searchQuery: '',
            filterStatus: 'Todos',

            // Estado para controle do Dialog Modal
            openModal: false,
            edit: {},
            delete: {},
            // Estado para o formulário do Novo cliente
            newSeller: {
                nome: '',
                doc: '',
                email: '',
                whatsapp: '',
                link: '',
                observacoes: '',
                ativo: true
            },

            // Lista de clientees inicializada com o dado do exemplo da imagem
            ClientsList: []
        };

        // Bind dos métodos
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.handleSaveSeller = this.handleSaveSeller.bind(this);
        this.handleEditSeller = this.handleEditSeller.bind(this);

    }
    componentDidMount() {
        fetch(`${process.env.REACT_APP_API_URL}/store/Clients`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Erro na requisição');
            })
            .then(data => {
                this.setState({ ClientsList: data });
            })
            .catch(err => console.error("Erro ao buscar clientees:", err));
    }

    handleTabChange(event, newValue) {
        this.setState({ currentTab: newValue });
    }

    handleSearchChange(event) {
        this.setState({ searchQuery: event.target.value });
    }

    handleFilterChange(event) {
        this.setState({ filterStatus: event.target.value });
    }

    // Abre o Modal de cadastro
    handleOpenModal() {
        this.setState({
            openModal: true,
            // Limpa o formulário ao abrir
            newSeller: {
                nome: '',
                email: '',
                whatsapp: '',
                link: '',
                observacoes: '',
                ativo: true
            }
        });
    }



    // Fecha o Modal
    handleCloseModal() {
        this.setState({ openModal: false });
    }

    // Monitora as mudanças nos campos de texto do formulário
    handleInputChange(event) {
        const { name, value } = event.target;
        this.setState(prevState => ({
            newSeller: {
                ...prevState.newSeller,
                [name]: value
            }
        }));
    }

    // Monitora o Switch de ativo/inativo
    handleSwitchChange(event) {
        const { checked } = event.target;
        this.setState(prevState => ({
            newSeller: {
                ...prevState.newSeller,
                ativo: checked
            }
        }));
    }

    // Salva o cliente na lista dinâmica
    handleSaveSeller(event) {
        event.preventDefault();
        const { newSeller, ClientsList } = this.state;


        fetch(`${process.env.REACT_APP_API_URL}/store/Clients/set`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(newSeller),
        })
            .then(res => {
                res.json().then(data => {
                    toast.success("cliente cadastrado com sucesso!");
                    const freshSeller = {
                        uuid: data.uuid,
                        ...newSeller,

                    };

                    this.setState({
                        ClientsList: [...ClientsList, freshSeller],
                        openModal: false // Fecha o modal após salvar
                    });
                })
            })
            .catch(error => {
                console.error('Erro ao cadastrar o cliente:', error);
            });



        // Criação de uma nova linha com dados iniciais zerados de performance

    }
    handleEditSeller(event) {
        event.preventDefault();



        fetch(`${process.env.REACT_APP_API_URL}/store/Clients/set`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.state.edit),
        })
            .then(response => {
                if (response.ok) {
                    toast.success("cliente atualizado com sucesso!");

                    this.setState((prevState) => ({
                        ClientsList: prevState.ClientsList.map((seller) => {
                            if (seller.uuid === this.state.edit.uuid) {
                                return this.state.edit;
                            }
                            return seller;
                        }),
                        edit: {}
                    }))

                } else {
                    toast.error('Erro ao cadastrar o cliente.');
                }
            })
            .catch(error => {
                console.error('Erro ao cadastrar o cliente:', error);
            });



        // Criação de uma nova linha com dados iniciais zerados de performance

    }

    render() {
        const { currentTab, searchQuery, filterStatus, openModal, newSeller, ClientsList } = this.state;

        // --- Lógica de Filtro dos clientees ---
        const filteredClients = ClientsList.filter(seller => {
            const matchesSearch = seller.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
                seller.email.toLowerCase().includes(searchQuery.toLowerCase());

            if (filterStatus === 1) return matchesSearch && seller.ativo;
            if (filterStatus === 0) return matchesSearch && !seller.ativo;
            return matchesSearch;
        });

        // --- Métricas Calculadas Dinamicamente ---
        const totalClients = ClientsList.length;
        const activeClients = ClientsList.filter(s => s.ativo).length;
        const totalOrders = ClientsList.reduce((acc, curr) => acc + curr.pedidos, 0);
        const totalRevenue = ClientsList.reduce((acc, curr) => acc + curr.receita, 0);
        const totalViews = ClientsList.reduce((acc, curr) => acc + curr.views, 0);

        // Estilo padrão para os cards de métricas
        const cardStyle = {
            borderRadius: '16px',
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            p: 1
        };

        const iconBoxStyle = (bgColor, iconColor) => ({
            width: 48,
            height: 48,
            borderRadius: '12px',
            backgroundColor: bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 2
        });

        return (
            <Box sx={{ p: 0, backgroundColor: '#f9f9f9', minHeight: '100vh' }}>

                {/* --- Topo: Cards de Métricas Dinâmicas --- */}
                <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={cardStyle}>
                            <CardContent sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Box sx={iconBoxStyle('#f3e8ff', '#9333ea')}>
                                    <PeopleIcon sx={{ color: '#9333ea' }} />
                                </Box>
                                <Box>
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>{totalClients}</Typography>
                                    <Typography variant="caption" color="textSecondary">{activeClients} ativos</Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={cardStyle}>
                            <CardContent sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Box sx={iconBoxStyle('#f3e8ff', '#9333ea')}>
                                    <ShoppingBagIcon sx={{ color: '#9333ea' }} />
                                </Box>
                                <Box>
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>{totalOrders}</Typography>
                                    <Typography variant="caption" color="textSecondary">Pedidos totais</Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Card sx={cardStyle}>
                            <CardContent sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Box sx={iconBoxStyle('#f3e8ff', '#9333ea')}>
                                    <AttachMoneyIcon sx={{ color: '#9333ea' }} />
                                </Box>
                                <Box>
                                    <Typography variant="h5" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>
                                        {totalRevenue?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">Receita total</Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>


                </Grid>

                {/* --- Linha de Ações: Abas e Botões Superiores --- */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                    <Box sx={{ backgroundColor: '#eeeeee', borderRadius: '12px', p: 0.5, display: 'inline-flex' }}>
                        <Tabs
                            value={currentTab}
                            onChange={this.handleTabChange}
                            sx={{ minHeight: 'auto', '& .MuiTabs-indicator': { display: 'none' } }}
                        >
                            <Tab
                                label="clientees"
                                icon={<PeopleIcon fontSize="small" />}
                                iconPosition="start"
                                sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    minHeight: '36px',
                                    py: 0.5,
                                    fontWeight: '500',
                                    '&.Mui-selected': { backgroundColor: '#ffffff', color: '#000000', boxShadow: '0px 2px 4px rgba(0,0,0,0.05)' }
                                }}
                            />
                            <Tab
                                label="Analytics"
                                icon={<BarChartIcon fontSize="small" />}
                                iconPosition="start"
                                sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    minHeight: '36px',
                                    py: 0.5,
                                    fontWeight: '500',
                                    '&.Mui-selected': { backgroundColor: '#ffffff', color: '#000000', boxShadow: '0px 2px 4px rgba(0,0,0,0.05)' }
                                }}
                            />
                        </Tabs>
                    </Box>

                    <Box sx={{ ml: 'auto', display: 'flex', gap: 2 }}>
                        <Button
                            variant="outlined"
                            startIcon={<FileDownloadIcon />}
                            endIcon={<Typography variant="caption" sx={{ ml: 0.5 }}>▼</Typography>}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '12px',
                                borderColor: '#e0e0e0',
                                color: '#666666',
                                '&:hover': { borderColor: '#cccccc', backgroundColor: '#f5f5f5' }
                            }}
                        >
                            Exportar
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={this.handleOpenModal}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '12px',
                                backgroundColor: '#7c3aed',
                                '&:hover': { backgroundColor: '#6d28d9' }
                            }}
                        >
                            Novo Cliente
                        </Button>
                    </Box>
                </Box>

                {/* --- Filtros de Busca --- */}
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <TextField
                        placeholder="Buscar cliente..."
                        variant="outlined"
                        size="small"
                        value={searchQuery}
                        onChange={this.handleSearchChange}
                        sx={{
                            width: '260px',
                            '& .MuiOutlinedInput-root': { borderRadius: '12px', backgroundColor: '#ffffff' }
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" color="disabled" />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <FormControl size="small" sx={{ width: '120px' }}>
                        <Select
                            value={filterStatus}
                            onChange={this.handleFilterChange}
                            sx={{ borderRadius: '12px', backgroundColor: '#ffffff' }}
                        >
                            <MenuItem value="Todos">Todos</MenuItem>
                            <MenuItem value="Ativos">Ativos</MenuItem>
                            <MenuItem value="Inativos">Inativos</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* --- Renderização Condicional: Tabela ou Estado Vazio --- */}
                {filteredClients.length === 0 ? (
                    <Box
                        sx={{
                            border: '1px dashed #e0e0e0',
                            borderRadius: '24px',
                            backgroundColor: '#ffffff',
                            p: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            minHeight: '350px'
                        }}
                    >
                        <Box
                            sx={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                backgroundColor: '#f3e8ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 3
                            }}
                        >
                            <PeopleIcon sx={{ color: '#7c3aed', fontSize: '28px' }} />
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: '600', mb: 1, color: '#1f2937' }}>
                            Nenhum cliente encontrado
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#6b7280', maxWidth: '400px', mb: 4 }}>
                            Cadastre clientees ou ajuste os filtros aplicados na pesquisa.
                        </Typography>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={this.handleOpenModal}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '12px',
                                backgroundColor: '#7c3aed',
                                px: 3,
                                py: 1,
                                '&:hover': { backgroundColor: '#6d28d9' }
                            }}
                        >
                            Cadastrar cliente
                        </Button>
                    </Box>
                ) : (
                    /* Tabela Layout correspondente à imagem 1 */
                    <TableContainer component={Paper} sx={{ borderRadius: '16px', boxShadow: '0px 2px 8px rgba(0,0,0,0.02)', border: '1px solid #f0f0f0' }}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#ffffff' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>cliente</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#666' }} align="center">Documento</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>WhatsApp</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#666' }}>Status</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', color: '#666' }} align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredClients.map((seller) => (
                                    <TableRow key={seller.id} hover>
                                        <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Avatar sx={{ bgcolor: '#f3e8ff', color: '#9333ea', fontSize: '14px', fontWeight: 'bold' }}>
                                                    {seller.nome.substring(0, 2).toUpperCase()}
                                                </Avatar>
                                                <Box>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{seller.nome}</Typography>
                                                    <Typography variant="caption" color="textSecondary">{seller.email}</Typography>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                        <TableCell align='center'>{seller.doc || '---'}</TableCell>
                                        <TableCell color="textSecondary">{seller.whatsapp || '-'}</TableCell>
                                        <TableCell>
                                            {seller.ativo ? (
                                                <Chip label="Ativo" size="small" sx={{ bgcolor: '#7c3aed', color: '#fff', fontWeight: '500' }} />
                                            ) : (
                                                <Chip label="Inativo" size="small" sx={{ bgcolor: '#e0e0e0', color: '#666', fontWeight: '500' }} />
                                            )}
                                        </TableCell>


                                        <TableCell align="center">

                                            <IconButton size="small" color="primary" onClick={() => {
                                                this.setState({ edit: seller })
                                            }}><EditIcon /></IconButton>

                                            <IconButton size="small" color="error" onClick={() => {
                                                this.setState({ delete: seller })
                                            }}>
                                                <DeleteIcon />
                                            </IconButton>

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}

                {/* --- DIALOG MODAL: Novo cliente (Idêntico ao layout da Imagem 2) --- */}
                <Dialog
                    open={openModal}
                    onClose={this.handleCloseModal}
                    maxWidth="xs"
                    PaperProps={{
                        sx: { borderRadius: '16px', padding: 2, maxWidth: '600px', width: '100%' }
                    }}
                >
                    <form onSubmit={this.handleSaveSeller}>
                        <DialogTitle sx={{ p: 1, fontWeight: 'bold', fontSize: '1.25rem' }}>
                            Novo cliente

                        </DialogTitle>

                        <DialogContent sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>

                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>Nome *</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    size="small"
                                    name="nome"
                                    placeholder="João Silva"
                                    value={newSeller.nome}
                                    onChange={this.handleInputChange}
                                    InputProps={{ sx: { borderRadius: '10px' } }}
                                />
                            </Box>

                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>E-mail *</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    type="email"
                                    size="small"
                                    name="email"
                                    placeholder="joao@email.com"
                                    value={newSeller.email}
                                    onChange={this.handleInputChange}
                                    InputProps={{ sx: { borderRadius: '10px' } }}
                                />

                            </Box>


                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, md: 6 }}>  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>Documento</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        type="text"
                                        size="small"
                                        name="doc"
                                        placeholder="000.000.000-00"
                                        value={newSeller.doc}
                                        onChange={this.handleInputChange}
                                        InputProps={{ sx: { borderRadius: '10px' } }}
                                    />

                                </Box></Grid>
                                <Grid size={{ xs: 12, md: 6 }}>  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>WhatsApp *</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        size="small"
                                        name="whatsapp"
                                        placeholder="(11) 99999-9999"
                                        value={newSeller.whatsapp}
                                        onChange={this.handleInputChange}
                                        InputProps={{ sx: { borderRadius: '10px' } }}
                                    />

                                </Box></Grid>

                            </Grid>







                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>Observações</Typography>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    size="small"
                                    name="observacoes"
                                    placeholder="Anotações internas sobre o cliente..."
                                    value={newSeller.observacoes}
                                    onChange={this.handleInputChange}
                                    InputProps={{ sx: { borderRadius: '10px' } }}
                                />
                            </Box>

                            {/* Botão Switch Ativo/Inativo */}
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 1.5,
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px'
                            }}>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: '600' }}>cliente ativo</Typography>
                                    <Typography variant="caption" color="textSecondary">clientees inativos não recebem pedidos</Typography>
                                </Box>
                                <Switch
                                    checked={newSeller.ativo}
                                    onChange={this.handleSwitchChange}
                                    color="secondary"
                                />
                            </Box>

                        </DialogContent>

                        <DialogActions sx={{ p: 1, mt: 2, gap: 1 }}>
                            <Button
                                onClick={this.handleCloseModal}
                                variant="outlined"
                                sx={{ textTransform: 'none', borderRadius: '10px', borderColor: '#e0e0e0', color: '#666' }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{ textTransform: 'none', borderRadius: '10px', backgroundColor: '#7c3aed', '&:hover': { backgroundColor: '#6d28d9' } }}
                            >
                                Salvar cliente
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>


                <Dialog
                    open={Object.keys(this.state.edit).length > 0}
                    onClose={() => {
                        this.setState({ edit: {} });

                    }}
                    maxWidth="xs"
                    PaperProps={{
                        sx: { borderRadius: '16px', padding: 2, maxWidth: '600px', width: '100%' }
                    }}
                >
                    <form onSubmit={this.handleEditSeller}>
                        <DialogTitle sx={{ p: 1, fontWeight: 'bold', fontSize: '1.25rem' }}>
                            Editar cliente

                        </DialogTitle>

                        <DialogContent sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 2.5, mt: 1 }}>

                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>Nome *</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    size="small"
                                    name="nome"
                                    placeholder="João Silva"
                                    value={this.state.edit.nome}
                                    onChange={(e) => {
                                        this.setState({
                                            edit: {
                                                ...this.state.edit,
                                                nome: e.target.value
                                            }
                                        })
                                    }}
                                    InputProps={{ sx: { borderRadius: '10px' } }}
                                />
                            </Box>

                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>E-mail *</Typography>
                                <TextField
                                    fullWidth
                                    required
                                    type="email"
                                    size="small"
                                    name="email"
                                    placeholder="joao@email.com"
                                    value={this.state.edit.email}
                                    onChange={(e) => {
                                        this.setState({
                                            edit: {
                                                ...this.state.edit,
                                                email: e.target.value
                                            }
                                        })
                                    }}
                                    InputProps={{ sx: { borderRadius: '10px' } }}
                                />

                            </Box>

                            <Grid container spacing={2}>

                                <Grid size={{ xs: 12, md: 6 }}>  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>Documento</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        type="text"
                                        size="small"
                                        name="doc"
                                        placeholder="000.000.000-00"
                                        value={this.state.edit.doc}
                                        onChange={(e) => {
                                            this.setState({
                                                edit: {
                                                    ...this.state.edit,
                                                    doc: e.target.value
                                                }
                                            })
                                        }}
                                        InputProps={{ sx: { borderRadius: '10px' } }}
                                    />

                                </Box></Grid>
                                <Grid size={{ xs: 12, md: 6 }}>  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>WhatsApp *</Typography>
                                    <TextField
                                        fullWidth
                                        required
                                        size="small"
                                        name="whatsapp"
                                        placeholder="(11) 99999-9999"
                                        value={this.state.edit.whatsapp}
                                        onChange={(e) => {
                                            this.setState({
                                                edit: {
                                                    ...this.state.edit,
                                                    whatsapp: e.target.value
                                                }
                                            })
                                        }}
                                        InputProps={{ sx: { borderRadius: '10px' } }}
                                    />

                                </Box></Grid>

                            </Grid>



                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: '500', mb: 0.5 }}>Observações</Typography>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={3}
                                    size="small"
                                    name="observacoes"
                                    placeholder="Anotações internas sobre o cliente..."
                                    value={this.state.edit.observacoes}
                                    onChange={(e) => {
                                        this.setState({
                                            edit: {
                                                ...this.state.edit,
                                                observacoes: e.target.value
                                            }
                                        })
                                    }}
                                    InputProps={{ sx: { borderRadius: '10px' } }}
                                />
                            </Box>

                            {/* Botão Switch Ativo/Inativo */}
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                p: 1.5,
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px'
                            }}>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: '600' }}>cliente ativo</Typography>
                                    <Typography variant="caption" color="textSecondary">clientees inativos não recebem pedidos</Typography>
                                </Box>
                                <Switch
                                    checked={this.state.edit.ativo}
                                    onChange={(e) => {
                                        this.setState({
                                            edit: {
                                                ...this.state.edit,
                                                ativo: e.target.checked
                                            }
                                        })
                                    }}
                                    color="secondary"
                                />
                            </Box>

                        </DialogContent>

                        <DialogActions sx={{ p: 1, mt: 2, gap: 1 }}>
                            <Button
                                onClick={this.handleCloseModal}
                                variant="outlined"
                                sx={{ textTransform: 'none', borderRadius: '10px', borderColor: '#e0e0e0', color: '#666' }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{ textTransform: 'none', borderRadius: '10px', backgroundColor: '#7c3aed', '&:hover': { backgroundColor: '#6d28d9' } }}
                            >
                                Salvar cliente
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>

                <Dialog
                    open={Object.keys(this.state.delete).length > 0}
                    onClose={() => {
                        this.setState({
                            delete: {}
                        })
                    }}
                    maxWidth="xs"
                    PaperProps={{
                        sx: { borderRadius: '16px', padding: 2, maxWidth: '600px', width: '100%' }
                    }}
                >
                    <DialogTitle>Remover cliente</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Tem certeza que deseja excluir <strong>{this.state.delete.nome}</strong>? Esta ação não pode ser desfeita e os dados de analytics serão perdidos.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 1, mt: 2, gap: 1 }}>
                        <Button
                            onClick={() => {
                                this.setState({
                                    delete: {}
                                })
                            }}
                            variant="outlined"
                            sx={{ textTransform: 'none', borderRadius: '10px', borderColor: '#e0e0e0', color: '#666' }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={() => {
                                fetch(`${process.env.REACT_APP_API_URL}/store/Clients/delete`, {
                                    method: 'POST',
                                    credentials: 'include',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify(this.state.delete)
                                })
                                    .then(res => {
                                        res.json().then(data => {
                                            toast.success('cliente removido com sucesso!');
                                            this.setState({
                                                ClientsList: this.state.ClientsList.filter(seller => seller.uuid !== this.state.delete.uuid),
                                                delete: {}
                                            });
                                        })
                                    })
                                    .catch(error => {
                                        console.error('Erro ao remover o cliente:', error);
                                    });
                            }}
                            variant="contained"
                            sx={{ textTransform: 'none', borderRadius: '10px', '&:hover': { backgroundColor: '#d32f2f' }, backgroundColor: '#f44336' }}
                        >
                            Remover cliente
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box>
        );
    }
}

export default Clients;